import React from "react";
import { Link } from "react-router-dom";
import { projectsData } from "../data/projectsData";
import LiveSiteFrame, { liveHost } from "./LiveSiteFrame";

const Projects = () => {
  return (
    <section id="projects" className="scroll-mt-24 bg-white py-20 text-ink lg:py-24">
      <div className="site-wrap">
        <div className="flex items-end justify-between gap-6">
          <div>
            <p className="label">Portfolio</p>
            <h2 className="mt-3 text-3xl font-light tracking-tight sm:text-4xl">
              Selected work
            </h2>
          </div>
          <p className="hidden font-mono text-[11px] uppercase tracking-[0.16em] text-mist sm:block">
            {String(projectsData.length).padStart(2, "0")} projects
          </p>
        </div>

        <div className="mt-10 grid gap-8 md:grid-cols-2 lg:gap-10">
          {projectsData.map((project, index) => {
            const live = project.liveUrl && project.liveUrl !== "#";

            return (
              <article key={project.id} className="work-piece">
                <div className="group/preview relative">
                  <LiveSiteFrame
                    compact
                    url={live ? project.liveUrl : undefined}
                    image={project.image}
                    name={project.name}
                  />
                  {live ? (
                    <a
                      href={project.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute inset-0 z-[2]"
                      aria-label={`Open ${project.name} live site`}
                    >
                      <span className="work-open">Visit live ↗</span>
                    </a>
                  ) : (
                    <Link
                      to={`/project/${project.id}`}
                      className="absolute inset-0 z-[2]"
                      aria-label={`${project.name} case study`}
                    />
                  )}
                </div>

                <div className="mt-4 flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-mist">
                      {String(index + 1).padStart(2, "0")} — {live ? liveHost(project.liveUrl) : project.type}
                    </p>
                    <h3 className="mt-1 truncate text-lg font-light tracking-tight">
                      {project.name}
                    </h3>
                  </div>
                  <Link
                    to={`/project/${project.id}`}
                    className="shrink-0 pt-4 text-[12px] text-ink/45 transition hover:text-ink"
                  >
                    Case study →
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Projects;
